const converter = (data) => {
  const dataset = []
  const labels = []

  const countries = {}
  data.forEach((obj) => {
    if (obj.country_code) {
      countries[obj.country_code] = obj.count
    } else {
      countries.NA = countries.NA ? countries.NA + obj.count : obj.count
    }
  })

  const sortedCountries = Object.entries(countries)
    .map(([country_code, count]) => ({ country_code, count }))
    .sort((a, b) => b.count - a.count)

  const topCountries = sortedCountries.slice(0, 5)
  const otherCountries = sortedCountries.slice(6, sortedCountries.length)
  topCountries.forEach((t) => {
    dataset.push(t.count)
    labels.push(t.country_code)
  })
  const countOtherCountries = otherCountries.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0)
  if (countOtherCountries > 0) {
    dataset.push(countOtherCountries)
    labels.push('Other')
  }

  if (dataset.length === 1 && dataset[0] === 0) {
    return { dataset: [], labels: [] }
  }

  return { dataset, labels }
}
export default converter
